export default __webpack_public_path__ + "static/media/1528.8c97ae09.png";